import { render, staticRenderFns } from "./batch-add.vue?vue&type=template&id=5be34694&scoped=true&"
import script from "./batch-add.vue?vue&type=script&lang=js&"
export * from "./batch-add.vue?vue&type=script&lang=js&"
import style0 from "./batch-add.vue?vue&type=style&index=0&id=5be34694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be34694",
  null
  
)

export default component.exports